import type { z } from 'zod'

// Distinct from a pre-send z.ZodError, so a caller can tell "never sent" apart from "placed but unparsable" and avoid reporting a real success as a checkout failure.
export class CheckoutResponseParseError extends Error {
  public override readonly cause: z.ZodError

  public constructor(cause: z.ZodError) {
    super('Checkout succeeded but the response could not be parsed.')
    this.name = 'CheckoutResponseParseError'
    this.cause = cause
  }
}
